import { useDataValue, useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'new_address',
  })
  let persons = useDataValue({
    context: 'same_address_persons',
    viewPath: props.viewPath,
  })
  return function useOnClick(value) {
    submit({
      type: 'address_for_patient',
      contact_method_id: persons?.[0].contact_method_id,
    })
  }
}
